<div id="about-us-container" class="web-center">
    <div class="our-mission-container">
        <div class="row">
            <div class="col-md-8 web-left">
                <div class="our-mission-text-box">
                    <h1 class="paragraph--title">Our Mission</h1>
                    <div class="paragraph-subtitle">Elevate every meal</div>
                    <div class="fm-rubik mt-4 fs-paragraph" style="width: 85%;">
                        At NutriGenic, we are committed to transforming the meal delivery experience
                        with a focus on <span class="fw-bold">excellence</span> and <span class="fw-bold">innovation</span>. 
                        Our mission is to provide a culinary journey <span class="fw-bold">unlike any other</span>, 
                        offering exquisitely crafted, <span class="fw-bold">premium quality meals</span> developed by renowned executive chefs 
                        in the culinary world.
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="our-mission-right-box">
                    <div class="our-mission-orange-arrows-up">
                        <img src="assets/images/3-orange-arrows-up.svg">
                    </div>
                    <div class="our-mission-image-box">
                        <img id="our-mission-image-short" src="assets/images/about-us-our-mission.png" class="w-100" style="border-radius: 25px;" alt="">
                        <img id="our-mission-image-long" src="assets/images/about-us-our-mission.png" class="w-100" style="border-radius: 25px;" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="our-funder-container">
        <div class="row">
            <div class="our-founder-image-box">
                <img src="assets/images/about-us-our-founder.png" class="w-100" alt="">
            </div>
            <div class="our-funder-text-box">
                <div class="our-funder-orange-arrows-down">
                    <img src="assets/images/3-orange-arrows-down.svg">
                </div>
                <div>
                    <h1 class="paragraph--title">Our Founder</h1>
                    <div style="width: 100%; text-box-trim: trim-both; text-box-edge: cap alphabetic; color: #2C2C30; font-size: 28px; font-family: Prompt; font-style: italic; font-weight: 700; letter-spacing: 1.40px; word-wrap: break-word">LEADING WITH FLAVOUR</div>
                    <div class="fm-rubik mt-4 fs-paragraph">
                       Our culinary journey began with the vision of our passionate founder, Taoufik Hannachi, an accomplished professional chef with over 20 years of experience in the culinary world. His culinary expertise and dedication to crafting exceptional meals form the cornerstone of our mission. <span class="inspired-by-inline">Inspired by a commitment to excellence and a love for creating memorable dining experiences, Taoufik leads our team of food and fitness professionals. His innovative spirit and unwavering dedication to customer satisfaction have propelled us to redefine the meal delivery experience.</span>
                    </div>
                </div>
                <div class="inspired-by-block">
                    <div style="width: 100%; text-box-trim: trim-both; text-box-edge: cap alphabetic; color: #2C2C30; font-size: 28px; font-family: Prompt; font-style: italic; font-weight: 700; letter-spacing: 1.40px; word-wrap: break-word">INSPIRED BY</div>
                    <div class="fm-rubik mt-4 fs-paragraph">
                        Inspired by a commitment to excellence and a love for creating memorable dining experiences, Taoufik leads our team of food and fitness professionals. His innovative spirit and unwavering dedication to customer satisfaction have propelled us to redefine the meal delivery experience.
                    </div>
                </div>
            </div>
            
        </div>
    </div>
    <div class="web-center shadow taoufik-sentence-container" style="z-index: 0;">
        <div class="taoufik-sentence-inner-container">
            <div>
                <svg class="mt-5" xmlns="http://www.w3.org/2000/svg" width="74" height="74" viewBox="0 0 74 74" fill="none">
                    <g style="mix-blend-mode:multiply">
                        <path d="M70.1997 50.0752C70.1997 51.8426 69.798 53.4092 68.9946 54.775C68.2715 56.0604 67.3075 57.145 66.1024 58.0288C64.8973 58.9125 63.5717 59.5954 62.1256 60.0774C60.7598 60.4791 59.4744 60.6799 58.2693 60.6799C56.4215 60.6799 54.5335 60.2783 52.6054 59.4749C50.7576 58.5911 49.0705 57.3459 47.544 55.7391C46.0176 54.1323 44.7723 52.2042 43.8082 49.9547C42.8442 47.7052 42.3621 45.2146 42.3621 42.4831C42.3621 37.7431 43.2459 33.686 45.0133 30.3117C46.8611 26.9375 49.0303 24.1256 51.5208 21.8761C54.0917 19.5462 56.7027 17.7386 59.3539 16.4532C62.0854 15.0874 64.3349 14.1233 66.1024 13.561V17.4172C64.4956 18.3813 62.7683 19.4257 60.9205 20.5505C59.153 21.6752 57.5061 23.0008 55.9796 24.5273C54.5335 26.0537 53.3284 27.781 52.3644 29.7092C51.4003 31.6373 50.9183 33.8065 50.9183 36.2166C50.9183 37.4217 51.0388 38.3858 51.2798 39.1089C51.5208 39.8319 51.802 40.3943 52.1234 40.796C52.5251 41.1977 52.8866 41.4789 53.2079 41.6395C53.6096 41.8002 53.931 41.8806 54.172 41.8806C55.0557 41.8806 56.1403 41.6395 57.4258 41.1575C58.7112 40.5951 59.9163 40.3139 61.041 40.3139C62.0854 40.3139 63.1298 40.555 64.1742 41.037C65.299 41.4387 66.3032 42.0814 67.187 42.9651C68.0707 43.7685 68.7938 44.7728 69.3561 45.9779C69.9185 47.1829 70.1997 48.5487 70.1997 50.0752ZM32.616 49.8341C32.616 51.6016 32.2143 53.1682 31.4109 54.534C30.6878 55.8998 29.7238 57.0245 28.5187 57.9082C27.3136 58.7116 25.988 59.3544 24.5419 59.8364C23.1761 60.2381 21.8505 60.4389 20.5651 60.4389C18.7173 60.4389 16.8695 60.0372 15.0217 59.2338C13.1739 58.3501 11.4867 57.145 9.9603 55.6186C8.43385 54.0118 7.1886 52.0836 6.22452 49.8341C5.34079 47.5846 4.89893 45.0941 4.89893 42.3626C4.89893 37.6226 5.78266 33.5654 7.55012 30.1912C9.39793 26.7366 11.5671 23.8846 14.0576 21.6351C16.6285 19.3052 19.2395 17.4976 21.8907 16.2122C24.5419 14.8464 26.7512 13.8823 28.5187 13.3199V17.2967C26.9119 18.2608 25.1846 19.3052 23.3368 20.43C21.5693 21.5547 19.9224 22.8803 18.3959 24.4068C16.9498 25.9332 15.7046 27.6605 14.6601 29.5886C13.6961 31.4365 13.214 33.6056 13.214 36.0961C13.214 38.3456 13.6559 39.8319 14.5396 40.555C15.5037 41.278 16.2268 41.6395 16.7088 41.6395C17.5122 41.6395 18.5566 41.3985 19.842 40.9165C21.1275 40.4345 22.3325 40.1934 23.4573 40.1934C24.5017 40.1934 25.5461 40.4345 26.5905 40.9165C27.7153 41.3182 28.7195 41.9609 29.6033 42.8446C30.487 43.648 31.21 44.6523 31.7724 45.8574C32.3348 46.9821 32.616 48.3077 32.616 49.8341Z" fill="#DFDFEF"/>
                    </g>
                </svg>
            </div>
            <div class="taoufik-sentence">
                From a young age, my interest lay in the joy of life, food, the ultimate happiness. My mother, the
                inspiring artwork, indulged my curiosity from a tender age and nurtured this inquisitiveness into a
                hunger. The rules I learned at my mother’s stove laid the unwavering foundation for my desire to be
                involved in food throughout my life.
                Food is my passion. Food is what resonates most deeply with me, with my core, with my sense of self.
            </div>
            <div>
                <img class="mb-5" src="assets/images/Taoufik-Hannachi.png" style="width: 18.929rem;height: 3.214rem;" alt="">
            </div>
        </div>
    </div>
    <div class="our-goal-container">
        <div class="row">
            <div class="our-goal-image-box">
                <img class="mb-5" src="assets/images/about-us-our-goal-with-arrow.png" class="w-100">
            </div>
            <div class="col-md-8 web-left our-goal-text-box">
                <div>
                    <h2 class="paragraph--title">Our Goal</h2>
                    <div style="width: 100%; text-box-trim: trim-both; text-box-edge: cap alphabetic; color: #BF6D08; font-size: 20px; font-family: Prompt; font-weight: 300; letter-spacing: 0.20px; word-wrap: break-word">Elite nutrition. Made simple</div>
                    <div class="mt-4 fm-rubik fs-paragraph">
                        We <span class="fw-bold">meticulously</span> craft each meal to meet specific dietary and fitness needs, harnessing the power of advanced analytics and the expertise of qualified nutritionists and fitness professionals to support our customers' wellness goals. With a focus on <span class="fw-bold">culinary artistry</span> and <span class="fw-bold">nutritional precision</span>, we are reshaping the way people experience and enjoy convenient, high-quality dining, one meal at a time.
                    </div>
                </div>
            </div>
            
        </div>

    </div>
    <div class="quality-experience-container">
        <div class="row">
            <div style="width: 100%; text-box-trim: trim-both; text-box-edge: cap alphabetic; text-align: center; color: #2C2C30; font-size: 28px; font-family: Prompt; font-style: italic; font-weight: 700; letter-spacing: 1.40px; word-wrap: break-word">QUALITY & EXPERIENCE</div>
            <div class="mt-5 mb-5">
                <div class="quality-boxes-container">
                    <div class="quality-box">
                        <img src="assets/images/user-star.svg" alt="">
                        <h3>Crafted by Chefs Backed by Science.</h3>
                        <p>Gourmet flavors meet elite-level nutrition—created by culinary pros and signed off by performance nutritionists.</p>
                    </div>
                    <div class="quality-box">
                        <img src="assets/images/serving-food.svg" alt="">
                        <h3>80+ Meal Choices Each Month Just Flavour</h3>
                        <p>Enjoy fresh, exciting options every month without ever repeating a meal.</p>
                    </div>
                    <div class="quality-box">
                        <img src="assets/images/timer.svg" alt="">
                        <h3>Skip the Mess Reclaim Your Time</h3>
                        <p>We handle planning, shopping, and cooking—so you can focus on what matters.</p>
                    </div>
                    <div class="quality-box">
                        <img src="assets/images/halal.svg" alt="">
                        <h3>Halal Certified</h3>
                        <p>Meals prepared under strict Islamic dietary laws for purity and quality assurance.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="feel-sustainability-container">
        <div class="feel-sustainability-content">
            <div class="feel-sustainability-title">FUEL SUSTAINABILITY</div>
            <div class="feel-sustainability-text">
                We are a team of food, nutrition, and fitness experts committed to sustainability at every step—from responsibly sourcing materials to cutting waste and carbon emissions. These practices are built into our business model and extended to our partners and suppliers, ensuring we protect natural resources and promote eco-friendly standards throughout our supply chain.
            </div>
        </div>
    </div>
    <div class="preformance-essentials-container">
        <div class="row">
            <div style="width: 100%; text-box-trim: trim-both; text-box-edge: cap alphabetic; text-align: center; color: #2C2C30; font-size: 28px; font-family: Prompt; font-style: italic; font-weight: 700; letter-spacing: 1.40px; word-wrap: break-word">PERFORMANCE ESSENTIALS</div>
            <div class="tiles-container mt-5">
                <div class="tile">
                    <div class="tile-image">
                        <img src="assets/images/performance-essentials_1.png" alt="">
                    </div>
                    <div class="tile-content">
                        <h3>
                            <div>Packed with 40g+ Protein</div>
                            &nbsp;
                            <div>Perfectly Balanced</div>
                        </h3>
                        <p>Over 40g of protein in every meal—engineered to crush hunger, power performance, and build lean muscle.</p>
                    </div>
                </div>
                <div class="tile">
                    <div class="tile-image">
                        <img src="assets/images/performance-essentials_2.png" alt="">
                    </div>
                    <div class="tile-content">
                        <h3>100% Real, Whole Foods<br>Nothing Less</h3>
                        <p>Clean, whole ingredients only—no ultra-processed junk—fueling real results.</p>
                    </div>
                </div>
                <div class="tile">
                    <div class="tile-image">
                        <img src="assets/images/performance-essentials_3.png" alt="">
                    </div>
                    <div class="tile-content">
                        <h3>Zero Artificial Ingredients<br>or UPFs</h3>
                        <p>No additives, no preservatives, no shortcuts—just pure, powerful fuel for your body.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="w-75 ready-to-elevate-your-meals-container">
        <div class="row">
            <div class="three-divs-container">
                <div class="content-div elevate-meals-3-arrows-down">
                    <img src="assets/images/3-orange-arrows-down.svg">
                </div>
                <div class="content-div elevate-your-meals-img">
                    <img src="assets/images/elevate-your-meals.png">
                </div>
                <div class="content-div elevate-meals-text-box">
                    <div class="elevate-meals-text">Ready to Elevate Your Meals?</div>
                    <app-orange-button text="Get Started" (action)="goToPlan()" />
                </div>
                <div class="content-div elevate-meals-3-arrows-right">
                    <img src="assets/images/3-orange-arrows-right.svg">
                </div>
            </div>
        </div>
    </div>
    <app-health-help></app-health-help>


</div>
